import type { TNavbarSpecialActions } from "../types/innerLayout/nav-links";

export const NAVBAR_SPECIAL_ACTIONS:
  Record<
    'LIVE_CHAT' | 'SUPPORT' | 'LANGUAGE' | 'SWITCH_DASHBOARD' | 'FEEDBACK' | 'CHATBOT' | 'REACH_PORTAL',
    TNavbarSpecialActions
  > = {
  LIVE_CHAT: 'live-chat',
  SUPPORT: 'support',
  LANGUAGE: 'language',
  SWITCH_DASHBOARD: 'switch-dashboard',
  FEEDBACK: 'feedback',
  CHATBOT: 'chatbot',
  REACH_PORTAL: 'reach-portal',
};
